"use strict";
/* eslint-disable no-control-regex */
Object.defineProperty(exports, "__esModule", { value: true });
exports.allowListCompanyNameCharRegex = exports.allowListPersonNameRegex = exports.allowListSingleLineCharRegex = exports.allowListMultiLineCharRegex = exports.textNoWhiteSpacesRegex = exports.textMultipleWhiteSpace = void 0;
/**
 * Regex that validates text
 *
 * - Checks more than single white space (e.g. 'a  b', 'a   b')
 */
exports.textMultipleWhiteSpace = /\s\s+/;
/**
 * Regex that validates text
 *
 * - Forbids all spaces in the text (e.g. 'a b', ' ab')
 */
exports.textNoWhiteSpacesRegex = /^\S*$/;
/**
 * Regex that validates multi-line text
 *
 * - Match a-z A-Z (including umlauts, Eszett)
 * - Match 0-9
 * - Match space, ! and the range of chars from # to ~ (it doesn't include the "")
 * - Match new line
 * - Match new line ASCII char
 */
exports.allowListMultiLineCharRegex = /^[a-zÀ-ȕ0-9 !#-~\n\x0C]+$/i;
/**
 * Regex that validates single-line text
 *
 * - Match a-z A-Z (including umlauts, Eszett)
 * - Match 0-9
 * - Match: [ ,.-_!/] (limited set of special chars)
 */
exports.allowListSingleLineCharRegex = /^[a-zÀ-ȕ0-9 ,.\-_!/]+$/i;
/**
 * Regex that validates person names
 *
 * - Match a-z A-Z (including umlauts, Eszett)
 * - Match 0-9
 * - Match: [ ,.\-'] (limited set of special chars)
 */
exports.allowListPersonNameRegex = /^[a-zÀ-ȕ0-9 ,.\-']+$/i;
/**
 * Regex that validates company names
 *
 * - Match a-z A-Z (including umlauts, Eszett)
 * - Match 0-9
 * - Match:  ,.\-_!&()+'/ (limited set of special chars)
 */
exports.allowListCompanyNameCharRegex = /^[a-zÀ-ȕ0-9 ,.\-_!&()+'/]+$/i;
